import React from 'react'
import { Grid, Typography } from '@mui/material'

import { CampaignStatusType, twinStatusesCodes, twinStatusesMap } from 'shared'

const getStatusColors = (code: string) => {
  switch (code) {
    // To DO remove old statuses
    case twinStatusesCodes['invite-declined']:
      return { backgroundColor: 'rgba(240, 58, 58, 0.20)', color: '#F03A3A' }
    case twinStatusesCodes['application-rejected']:
      return { backgroundColor: 'rgba(25, 135, 84, 0.20)', color: '#198754' }
    case twinStatusesCodes['application-submitted']:
      return { backgroundColor: 'rgba(25, 135, 84, 0.20)', color: '#198754' }
    case twinStatusesCodes['content-submitted']:
      return { backgroundColor: 'rgba(170, 215, 211, 0.20)', color: '#73C2BB' }
    case twinStatusesCodes['application-approved']:
      return { backgroundColor: 'rgba(25, 135, 84, 0.20)', color: '#198754' }
    case twinStatusesCodes['kit-shipped']:
      return { backgroundColor: '#E4CAFB', color: '#03101D' }
    case twinStatusesCodes['invite-accepted']:
      return { backgroundColor: 'rgba(234, 159, 123, 0.20)', color: '#EA9F7B' }
    // New statuses
    case twinStatusesCodes.unassigned:
    case twinStatusesCodes.shortlisted:
      return { backgroundColor: '#D8DAFF', color: '#430B65' }
    case twinStatusesCodes.pass_waitlist:
      return { backgroundColor: '#E9E9E9', color: '#3D3D3D' }
    case twinStatusesCodes.enrolled:
      return { backgroundColor: '#E8F3EE', color: '#085014' }
    case twinStatusesCodes.submitted:
      return { backgroundColor: '#D9EDFF', color: '#0B0F65' }
    case twinStatusesCodes.overdue:
      return { backgroundColor: '#FEE3FF', color: '#670B42' }
    case twinStatusesCodes.exempted:
      return { backgroundColor: '#F9FFB9', color: '#544807' }
    default:
      return { backgroundColor: '#EFECF1', color: '#03101D' }
  }
}

const CampaignTwinStatus = ({
  status,
  className = '',
}: {
  status: CampaignStatusType | undefined
  className?: string
}) => {
  if (!status) return null
  const { backgroundColor, color } = getStatusColors(status.code)
  const title = twinStatusesMap[status.code as keyof typeof twinStatusesMap]

  if (!title) return null
  return (
    <Grid
      sx={{
        borderRadius: '100px',
        padding: '8px 12px 6px 12px',
        backgroundColor: backgroundColor,
        width: 'max-content',
        color: color,
        border: `1px solid ${color}`,
      }}
      className={className}
    >
      <Typography
        sx={{
          fontWeight: 500,
          lineHeight: '10px',
          fontSize: '12px',
          textTransform: 'uppercase',
        }}
      >
        {title}
      </Typography>
    </Grid>
  )
}

export default CampaignTwinStatus
